<template>
  <div id="pageRoot">
    <p id="text01" class="textBase pageElement">
      Lo llamaron una vez, dos, y a la tercera vez el hombrecito los oyó. Se
      levantó y sin hablar, los llevo al comedor, donde habia una mesa cubierta
      con los mas exquisitos manjares: pollos asados, pescados, carnes,
      ensaladas, verduras, sopas, tortas, helados, flanes. ¡Como comieron los
      tres! ¡Hasta quedar repletos y un poquito más también! Entonces el
      hombrecito los llevo a todos a un dormitorio. Enseguida se quedaron
      dormidos<br /><br />
      A la mañana siguiente, el hombrecito despertó al hermano mayor, lo llevo a
      una mesa de piedra, sobre la que estaban escrita las tres pruebas que
      había que superar para desencantar el palacio.<br /><br />
      La primera prueba consistía en recoger las mis perlas que la princesa
      Catalina había perdido en el bosque. Si antes de la puesta de sol faltaba
      una sola perla, el caballero que realizaba la prueba se convertiría en
      piedra.<br /><br />
      El príncipe fue al bosque y se pasó el día entero recogiendo perlas. Al
      atardecer, solo había encontrado cien. No bien se hizo de noche, quedó
      convertido en piedra.<br /><br />
      Al día siguiente, el segundo hermano intentó lo mismo. Al atardecer, tenía
      doscientas perlas. Así que también él quedo petrificado.
    </p>
  </div>
</template>
<style scoped>
#text01 {
  position: absolute;
  left: 41px;
  top: 28px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 9.mp4", "cas/Video 10bv2.mp4", "cas/Video 10c.mp4", ],
    };
  },
};
</script>
